import React, { Component } from "react";

import { withTranslation } from "react-i18next";
import {
  IconButton,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export class HL7Layout extends Component {
  render() {
    const {
      t,
      classes,
      handleClickHL7XApiKey,
      handleMouseDownHL7APIKey,
      showXApiKey,
      readOnly,
      x_api_key,
      handleChangeHL7XApiKey,
    } = this.props;
    return (
      <React.Fragment>
        <div style={{ display: "flex" }}>
          <FormControl
            className={classes.formControl}
            style={{ marginTop: "15px" }}
          >
            <InputLabel htmlFor="password" style={{ marginLeft: "-1rem" }}>
              {t("Accounts.Connect.MScripts.XApiKey")}
            </InputLabel>
            <Input
              className={classes.halfTextField}
              margin="normal"
              value={x_api_key || ""}
              id="hl7_x_api_key"
              name="hl7_x_api_key"
              type={showXApiKey ? "text" : "password"}
              inputProps={{ readOnly: Boolean(readOnly) }}
              label="Password"
              placeholder=""
              onChange={handleChangeHL7XApiKey}
              validators={["required"]}
              errorMessages={[t("Validation.EnterXApiKey")]}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickHL7XApiKey}
                    onMouseDown={handleMouseDownHL7APIKey}
                  >
                    {showXApiKey ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </div>
      </React.Fragment>
    );
  }
}

export default (withTranslation()(HL7Layout));



// WEBPACK FOOTER //
// ./src/components/account-list/third-party/Hl.js